export class Lead {
	constructor() {
		//console.log('class Lead');
	}

	//нужна консультация
	sendZayav(parent) {
		this.send(parent, 17, "form");
		return false;
	}

	sendNewZayav(parent) {
		this.send(parent, 25, "form");
		return false;
	}

	send(parent, mid, leadName) {
		$(document).css("cursor", "wait");
		var el = $(parent);
		var submit = el.find("input[type='submit']");

		// Лог сериализованных данных формы
		console.log('Данные формы:', el.serialize());
		// Лог заголовка страницы
		console.log('Заголовок страницы:', document.title);

		$.ajax({
			url: "/ajax.php?mid=" + mid,
			type: "POST",
			data: el.serialize() + "&str_page=" + document.title + "&mode=send_request",
			dataType: "json",
			beforeSend: function() {
				// Лог перед отправкой запроса
				console.log('Перед отправкой данных на сервер');
				submit.prop("disabled", true);
			},
			success: function(res) {
				// Лог успешного ответа от сервера
				console.log('Ответ от сервера:', res);
				if (res["success"]) {
					submit.prop("disabled", true);
					el.trigger('reset');

					// Лог успешной отправки формы
					console.log('Заявка успешно отправлена, скрываю форму.');
					$(".contacts-page-block-info-form-desc").hide();
					el.hide(); // скрыть форму
					$(".contacts-page-block-info-form-success").css('display', 'flex');

					$(document).css("cursor", "auto");

				} else {
					// Лог ошибки от сервера
					console.error('Ошибка от сервера:', res["error"]);
					alert(
						"Ошибка: " +
							res["error"] +
							". Пожалуйста, повторите попытку или свяжитесь с нами. Приносим извинения за неудобства."
					);
					$(document).css("cursor", "auto");
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				// Лог ошибки AJAX-запроса
				console.error('Ошибка при выполнении запроса:', textStatus, errorThrown);
				alert("Ошибка при отправке данных. Пожалуйста, попробуйте позже.");
				$(document).css("cursor", "auto");
			},
			complete: function() {
				// Лог завершения запроса
				console.log('Запрос завершён');
				submit.prop("disabled", false); // Включить кнопку отправки после завершения запроса
			}
		});
	}
}
